import React from 'react';
import './index.scss';
import novoice from '../../../assets/image/novoice@3x.png';
import voice from '../../../assets/image/voice@3x.png';
import play from '../../../assets/image/play@3x.png';
import stop from '../../../assets/image/stop@3x.png';
import fill from '../../../assets/image/fill@3x.png';

let t = 0;
class ArticleVideo extends React.Component {
  state = {
    video: {},
    progressBar: null,
    isFull: false,
    videoHeight: 0,
    minHeight: 0,
    videoStyle: {},
    hideVideoVoiceIcon: false
  }

  constructor() {
    super()

    this.play = this.play.bind(this);
    this.loadOver = this.loadOver.bind(this);
    this.changeVoice = this.changeVoice.bind(this);
    this.timeUpdte = this.timeUpdte.bind(this);
    this.handleTime = this.handleTime.bind(this);
    this.fullScreen = this.fullScreen.bind(this);
    this.controlProgress = this.controlProgress.bind(this);
    this.moveProgress = this.moveProgress.bind(this);
    this.windowOnScroll = this.windowOnScroll.bind(this);
    this.showVideoIcon = this.showVideoIcon.bind(this);
  }

  bindVideoRef = e => {
    if (e) {
      e.muted = true;
    } else {
      return
    }
    this.setState({
      video: e,
      videoHeight: e.getBoundingClientRect().height,
      minHeight: 289 * e.getBoundingClientRect().height / 465,
      videoStyle: {
        height: e.getBoundingClientRect().height + 'px',
        // position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999
      },

    }, function () {
      window.addEventListener('scroll', this.windowOnScroll);
      // this.section1.style.height = e.getBoundingClientRect().height + 'px';
    })
  }

  bindVideoProgressBar = e => {
    this.setState({
      progressBar: e,
    })
  }

  componentDidMount() {
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.windowOnScroll)
  }

  componentWillReceiveProps(props) {
    if (props.startPlay) {
      this.play();
      this.showVideoIcon();
    }
  }

  /**
   *  video 初始大小 750rpx 465rpx
   *        最小：   495rpx 289rpx
   *        比例：   1.51   1.61
   * @returns {*}
   */
  windowOnScroll() {
    let _this = this;

    let { videoHeight, minHeight } = this.state;
    if (_this.state.isFull) {
      return;
    } else {
      //获取滚动条滚动的距离
      let sTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      setTimeout(function () { t = sTop }, 0);
      if (sTop > t) {
        if (_this.section0.style.height == minHeight + 'px') {
          return
        }
        if (sTop > 0) {
          // _this.section0.style.height = minHeight + 'px';
          // _this.section0.style.transition = 'height .6s';
          // _this.section1.style.height = minHeight + 'px';
        }
      } else {
        if (_this.section0.style.height == videoHeight + 'px') {
          return
        }
        if (sTop < videoHeight) {
          // _this.section0.style.height = videoHeight + 'px';
          // _this.section0.style.transition = 'height .6s';
          // _this.section1.style.height = videoHeight + 'px';
        }
      }
    }
  }


  /**
   * 切换播放状态
   */
  play() {
    const {
      video,
    } = this.state;
    if (video.paused) {
      // pause
      video.play()
      let _this = this;
      let timer = setTimeout(() => {
        if (!video.paused) {
          _this.setState({
            hideVideoVoiceIcon: true
          })
        }
        clearTimeout(timer)
      }, 3000);

    } else {
      // play
      video.pause();
      // debugger
    }

    this.setState({
      video,
    })
  }

  showVideoIcon(e) {
    let { hideVideoVoiceIcon, video } = this.state;
    if (hideVideoVoiceIcon) {
      this.setState({
        hideVideoVoiceIcon: false
      })
      if (!video.paused) {
        let _this = this;
        let timer = setTimeout(() => {
          if (!video.paused) {
            _this.setState({
              hideVideoVoiceIcon: true
            })
          }
          clearTimeout(timer)
        }, 3000);
      }
    }
  }

  /**
   * 切换声音
   */
  changeVoice(e) {
    const {
      video
    } = this.state;

    video.muted = !video.muted;

    this.setState({
      video,
    })
  }

  /**
   * 监听视频加载完成， 获取视频长度, 将秒数
   * @returns {*}
   */
  loadOver() {
    const {
      video
    } = this.state;

    this.setState({
      video,
    })
  }

  /**
   * 监听播放状态， 获取已播放时长
   * @returns {*}
   */
  timeUpdte() {
    const {
      video,
    } = this.state;

    this.setState({
      video,
    })
  }

  /**
   * 处理时长： 分， 秒
   */
  handleTime(time) {
    let mm = parseInt(time / 60);
    let ss = parseInt(time - mm * 60);
    mm = mm < 10 ? '0' + mm : mm;
    ss = ss < 10 ? '0' + ss : ss;
    return {
      mm,
      ss
    }
  }

  /**
   * 全屏播放
   * @returns {*}
   */
  fullScreen() {
    // 把height存起来， height设置为100%
    if (!this.state.isFull) {
      this.setState({
        _videoStyle: this.state.videoStyle,
        videoStyle: {
          objectFit: fill
        }
      })
    } else {
      // 把存起来的height拿出来
      this.setState({
        videoStyle: this.state._videoStyle
      })
    }
    this.setState({
      isFull: !this.state.isFull
    })
  }

  /**
   * 点击进度条，控制进度
   * @returns {*}
   */
  controlProgress(e) {
    const {
      progressBar
    } = this.state;

    let percent = (e.clientX - progressBar.offsetLeft) / progressBar.offsetWidth;
    let video = this.state.video;
    video.currentTime = video.duration * percent;
    this.setState({
      video: video
    })
  }

  /**
   * 拖动进度条，控制进度
   * @returns {*}
   */
  moveProgress(e) {
    const {
      progressBar,
      video
    } = this.state;

    let percent = (e.touches[0].pageX - progressBar.offsetLeft) / progressBar.offsetWidth;
    video.currentTime = video.duration * percent;
    this.setState({
      video
    })
  }

  render() {
    let {
      video,
      videoStyle,
      hideVideoVoiceIcon
    } = this.state;

    let {
      src
    } = this.props;

    let long = '';
    let currentTime = '';

    if (!video) {
      return '';
    }
    if (video.duration) {
      long = this.handleTime(video.duration)
      long = `${long.mm}:${long.ss}`
    }

    if (video.currentTime > 0) {
      currentTime = this.handleTime(video.currentTime);
      currentTime = `${currentTime.mm}:${currentTime.ss}`
    }
    return (
      <section>
        <div className={this.state.isFull ? 'videoFullScreen' : 'articleHeaderVideoBox'}
          ref={section => {
            this.section0 = section
          }}
          style={videoStyle}
        >
          <video
            className={'articleHeader_video'}
            data-type='articleHeader_video'
            onLoadedMetadata={this.loadOver}
            onTimeUpdate={this.timeUpdte}
            ref={this.bindVideoRef}
            proload="metadata"
            x5-video-player-type="h5"
            x-webkit-airplay="allow"
            webkit-playsinline="true"
            playsInline
            src={src}
          />
          <div className="videoControls">
            {

              (video.paused && (!currentTime || (currentTime === '00:00'))) && <img className='tempShowVoicebtn' src={src + '?x-oss-process=video/snapshot,t_7000,f_jpg,w_0,h_0,m_fast'} alt="video snapshot" />
            }
            {
              !hideVideoVoiceIcon && <img onClick={this.play} className='videoPlay' src={video.paused ? play : stop} alt="play icon" />
            }
            <div className="mainControls">
              <img
                onClick={(e) => { this.changeVoice(e); }}
                className='videoVoice'
                src={video.muted ? novoice : voice}
                alt="voice icon" 
              />
              <span className='currentProgressValue'>{currentTime || '00:00'}</span>
              <div onClick={this.controlProgress}
                ref={this.bindVideoProgressBar}
                className='videoProgressBg'>
                <div className="videoRealyProgressBg"
                  style={{ width: (video.currentTime / video.duration) * 100 + '%' }}>
                  <div
                    onTouchMove={this.moveProgress}
                    className="videoCurrentBg"
                  ></div>
                </div>
              </div>
              <span className='maxProgressValue'>{long || '00:00'}</span>
              <img onClick={this.fullScreen} className='videoFill' src={fill} alt="full screen icon" />
            </div>
            <div className="tempShowVoicebtn" onClick={this.showVideoIcon}></div>
          </div>
          <div className='halfCircle'></div>
        </div>
        {/* <div ref={section => { this.section1 = section }}></div> */}
      </section>

    )
  }
}

export default ArticleVideo